import React from 'react';
import { Box, Paper, Typography, alpha, useTheme } from '@mui/material';

export default function StatTile({ icon, label, value, color, muted }) {
  const theme = useTheme();
  const c = muted ? theme.palette.text.disabled : color;

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 1.75,
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        borderColor: muted ? 'divider' : alpha(c, 0.3),
        bgcolor: muted ? 'transparent' : alpha(c, 0.06),
      }}
    >
      <Box
        sx={{
          width: 36,
          height: 36,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: alpha(c, muted ? 0.08 : 0.15),
          color: c,
          flexShrink: 0,
        }}
      >
        {icon}
      </Box>
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="caption" color="text.secondary" noWrap>{label}</Typography>
        <Typography variant="h6" fontWeight={700} sx={{ color: muted ? 'text.primary' : c, lineHeight: 1.2 }}>
          {value}
        </Typography>
      </Box>
    </Paper>
  );
}
